import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from "@material-ui/core/styles/withStyles";

import disqusPollStyle from "assets/jss/material-kit-react/views/pollTemplateSections/disqusPollStyle.jsx";

// original code from https://github.com/debiki/gatsby-plugin-ed-comments/blob/master/src/index.js
// borrowed some code, dont need whole package

let scriptTagAdded = false;

function addScriptTagOnce() {
  if (scriptTagAdded) {
    return;
  }

  const scriptElem = document.createElement('script');
  const headOrBodyElem =
      document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0];

  scriptElem.async = true;
  scriptElem.type = 'text/javascript';
  scriptElem.src = window.talkyardScriptUrl || 'https://c1.ty-cdn.net/-/talkyard-comments.min.js';
  window.talkyardServerUrl = 'https://comments-for-pollpals-com.talkyard.net';

  headOrBodyElem.appendChild(scriptElem);
  scriptTagAdded = true;
}

class TalkYardComments extends Component {
  constructor(props) {
      super(props);
    }

    componentDidMount() {
      const isReMounting = scriptTagAdded;
      addScriptTagOnce();
      if (isReMounting) {
        // The user have navigated to a new page, via history.push() and un/remounting components.
        // We need to reload comments, for this new URL.
        // But maybe the user har clicked links to new pages super quickly, so the script hasn't
        // loaded yet, so check if the fn exists.
        if (window.talkyardReloadCommentsAndEditor) {
          window.talkyardReloadCommentsAndEditor();
        }
      }
    }

    componentWillUnmount() {
      if (window.talkyardRemoveCommentsAndEditor) {
        window.talkyardRemoveCommentsAndEditor();
      }
    }

    render() {
      const {classes} = this.props;
      return (
        <div className={classes.section}>
          <div className={classes.comments}>
            <h3 className={classes.commentHeader}>Continue the conversation and comment below!</h3>
            <div className='talkyard-comments' data-discussion-id={this.props.discussionId || ''} data-talkyard-page-id={this.props.talkyardPageId || this.props.edPageId || ''}>
              <noscript>Please enable Javascript to view comments.</noscript>
              <p style={{ marginTop: 25, opacity: 0.9, fontSize: '96%' }}>
                Comments powered by <a href='https://www.talkyard.io'>Talkyard</a>.
              </p>
            </div>
          </div>
        </div>
      );
    }
}

const pageWithStyles = withStyles(disqusPollStyle)(withRouter(TalkYardComments));

export default pageWithStyles;



// WEBPACK FOOTER //
// ./src/views/PollTemplate/TalkYardComments.js